import { Route } from "vue-router/types";
import { UserService } from "@/modules/auth/services/UserService";

export const globalSubscribe = (to: Route, from: Route) => {
  new UserService().getCachedQcUser().then((res) => {
    if (res.isErr()) {
      console.error("Failed to get user info from cache", res.error);
      return;
    }
  });
};
